import camelCase from 'lodash/camelCase'
import { FormattedMessage } from 'react-intl'

import { useFormatMessage } from '@acre/utils'

import type { Variant } from '../../utils/constants'
import testHandle from '../../utils/testHandle'
import Tag from '../Tag/Tag'
import { GreyText } from '../Text/Text'
import { STATUS_INTL, STATUS_TAG_COLOUR } from './CaseStatusTag.helpers'

export type CaseStatusProps = {
  status?: CaseStatus | null
  variant?: Variant
}

const CaseStatusTag = ({ status, variant }: CaseStatusProps) => {
  const formatMessage = useFormatMessage()

  if (status) {
    return (
      <Tag
        id="CaseOverviewCaseType"
        text={formatMessage(STATUS_INTL[status])}
        colourID={STATUS_TAG_COLOUR[status]}
        data-testid={testHandle(`case-${camelCase(status)}`)}
        variant={variant}
      />
    )
  }
  return (
    <GreyText>
      <FormattedMessage id="generic.noInformation" />
    </GreyText>
  )
}

export default CaseStatusTag
